import { Component,OnInit } from '@angular/core';
import { ModalController,NavParams,LoadingController,ToastController,AlertController } from 'ionic-angular';
import { DTOListaCatalogo } from '../../dto/dtoListaCatalogo';
import { PedidoDAO } from '../../daos/pedido-dao';
import { AppModule } from '../../app/app.module';
import { CadastroReferenciaManterPage } from '../cadastro-referencia-manter/cadastro-referencia-manter';



import _ from 'lodash';


@Component({
    selector: 'page-cadastro-referencia',
    templateUrl: 'cadastro-referencia.html'
})
export class CadastroReferenciaPage implements OnInit{
    public listaCatalogo: DTOListaCatalogo[] = [];
    public listaCatalogoOriginal: DTOListaCatalogo[] = [];
    public qtdePicotes: number;
    searchTerm: string;

    constructor(private _loadingCtrl: LoadingController,_navParams: NavParams,
        private _alertCtrl: AlertController,
        private _toastCtrl: ToastController,
        private _modalCtrl: ModalController,
        private _pedidoDAO: PedidoDAO) {        
 
    }

    ngOnInit(): void {
        this.qtdePicotes = 50;
        this.obterCatalogo();
              
    }

    public obterCatalogo(): void {  
        let load = this._loadingCtrl.create({ content: 'Obtendo catalogo...' });
        load.present();
        this._pedidoDAO.listaCatalogo(AppModule.getEmpresa().Id).then(lista => {    
        this.listaCatalogoOriginal = lista;

        

        this.listaCatalogo = lista.filter(a => _.isEqual(a.QtdePicote, this.qtdePicotes)); 

        load.dismiss();
        }).catch(error => {
        this._toastCtrl.create({
            message: 'Ocorreu um erro ao tentar obter catalogo. Tente novamente!',
            duration: 3000
        }).present();
        console.error(error);
        load.dismiss();
        });  
    }

    public removerReferencia(item): void {    
        this._alertCtrl.create({
            title: 'Têm certeza que deseja remover a referência',
            subTitle: `Após a confirmação, a referência nº ${item.Referencia} será removida.`,

            buttons: [
                {
                    text: 'Não',
                    role: 'destructive'
                },
                {
                    text: 'Sim',
                    handler: (data) => {
                     //console.log(AppModule.getEmpresa());
                        console.log(item);

                
                        this._pedidoDAO.deletarCatalogo(item)                        
                            .then(r => {
                                this.alertaDeSucesso('Catalogo removido com sucesso');
                                const index = this.listaCatalogo.indexOf(item);
                                this.listaCatalogo.splice(index, 1);

                            }, err => {
                                this.alertaErro(`Houve um erro inesperado. ${err.mensagem}`);
                            });  
                                            
                        
                        
                    }
                }
            ]
        }).present();                 
        
    }

    alertaErro(msg: string) {
        this._alertCtrl.create({
            message: msg,
            title: 'Ops... 😔',
            buttons: [{
                text: 'Ok, estou ciente'
            }]
        }).present();
    }


    alertaDeSucesso(msg: string) {
      this._alertCtrl.create({
          message: msg,
          title: 'Sucesso 😀 ️',
          buttons: [{
              text: 'Ok'
          }]
      }).present();
    }

    public consultaporPicote(): void {
        var lista = this.listaCatalogoOriginal
        if (this.qtdePicotes == 50) {
            this.listaCatalogo = lista.filter(a => _.isEqual(a.QtdePicote, 50)); 
        }else{
            this.listaCatalogo = lista.filter(a => _.isEqual(a.QtdePicote, 100)); 
        }
        
    }

    public criarOuEditar(dtoListaCatalogo?: DTOListaCatalogo): void {

        let modal = this._modalCtrl.create(CadastroReferenciaManterPage, { dtoListaCatalogo: dtoListaCatalogo, qtdePicotes:this.qtdePicotes });

        modal.onDidDismiss(cadastrou => {
           //if (cadastrou)
                this.obterCatalogo();
        });
        

        modal.present();
    }




    

}


// WEBPACK FOOTER //
// ./src/pages/cadastro-referencia/cadastro-referencia.ts